export class SummernoteImageUpload {
  public constructor(
    public readonly url: string,
    public readonly title: string,
  ) {}
}
